'use client';

import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
interface AnalyticsProviderProps {
  children: React.ReactNode;
}

/**
 * AnalyticsProvider — provides the analytics SDK React context to the component tree.
 *
 * PostHog is initialized in observability/setup/bootstrap-client.ts (not here)
 * to avoid React Strict Mode double-execution issues. This component only
 * wraps the app to enable React hooks like usePostHog().
 *
 * To switch analytics vendors:
 *   1. Update observability/setup/bootstrap-client.ts to initialise the new SDK
 *   2. Replace the provider wrapper below with the new SDK's context provider
 *   3. Update observability/analytics/providers/ accordingly
 */
export function AnalyticsProvider({
  children
}: AnalyticsProviderProps) {
  return <PHProvider client={posthog} data-sentry-element="PHProvider" data-sentry-component="AnalyticsProvider" data-sentry-source-file="analytics-provider.tsx">{children}</PHProvider>;
}